var colors = {
  // Core
  darkCore: '#ff5e00',
  core: '#fe8c00',
  sunlight: '#fff496',
  // Sale
  rouge: '#ff5a52',
  // Label
  warmBlack: '#323220',
  grass: '#158620',
  // Primary colors
  wave: '#3d6778',
  lightTeal: '#b0ccca',
  silver: '#d6e2e5',
  olive: '#70763d',
  lightOlive: '#c0cba2',
  hazel: '#8f5000',
  sand: '#eee1d2',
  // UI colors
  black: '#000',
  almostblack: '#202020',
  darkGray: '#454545',
  darkGrayL1: '#707070',
  mediumGray: '#adadad',
  mediumGrayL1: '#c7c7c7',
  lightGray: '#e3e3e3',
  lightGrayL1: '#ededed',
  extraLightGray: '#f7f7f7',
  white: '#fff',
  lightSand: '#f9f5f1',
  lightSunlight: '#fdf8cf',
  ocean: '#359cbb',
  oceanL1: '#60b9d4',
  morello: '#e42a25',
  morelloL1: '#e74b3f',
  spreadShadow: '#dfdfdf',
  // Globetrotter
  darkGlobe: '#172b54',
  darkGlobeL1: '#3a4b6d',
  globe: '#7594b3',
  globeL1: '#89a4be',
  latte: '#a48c6a',
  lightRouge: '#fabaac',
  mora: '#4c1029',
  moraL1: '#673448',
  // Spies
  mango: '#f6b637',
  // Other
  tripadvisor: '#589442',
  // Validation 
  validationErrorBg: '#facac7',
  validationErrorText: '#8f271f',
  validationErrorBorder: '#fd9e99',
  validationValid: '#1d9886'
};
var transparentColors = {
  transparent: 'rgba(255, 255, 255, 0)',
  semiTransparent: 'rgba(255, 255, 255, .5)',
  semiTransparent10: 'rgba(255, 255, 255, .1)',
  semiTransparent20: 'rgba(255, 255, 255, .2)',
  semiTransparent30: 'rgba(255, 255, 255, .3)',
  semiTransparent40: 'rgba(255, 255, 255, .4)',
  semiTransparent50: 'rgba(255, 255, 255, .5)',
  semiTransparent60: 'rgba(255, 255, 255, .6)',
  semiTransparent70: 'rgba(255, 255, 255, .7)',
  semiTransparent80: 'rgba(255, 255, 255, .8)',
  semiTransparent90: 'rgba(255, 255, 255, .9)',
  semiTransparentblack: 'rgba(0, 0, 0, .5)',
  semiTransparentblack10: 'rgba(0, 0, 0, .1)',
  semiTransparentblack20: 'rgba(0, 0, 0, .2)',
  semiTransparentblack30: 'rgba(0, 0, 0, .3)',
  semiTransparentblack40: 'rgba(0, 0, 0, .4)',
  semiTransparentblack50: 'rgba(0, 0, 0, .5)',
  semiTransparentblack60: 'rgba(0, 0, 0, .6)',
  semiTransparentblack70: 'rgba(0, 0, 0, .7)',
  semiTransparentblack80: 'rgba(0, 0, 0, .8)',
  semiTransparentblack90: 'rgba(0, 0, 0, .9)',
  semiTransparentwave90: 'rgba(61, 103, 120, .9)'
};
var colorAliases = {
  background: colors.lightSand,
  overlay: transparentColors.semiTransparentblack,
  shadow: colors.mediumGrayL1,
  textGray: colors.mediumGray,
  textwhite: colors.white,
  text: colors.darkGray,
  validationError: colors.morello,
  validationValid: colors.ocean
};

export { colorAliases, colors, transparentColors };
//# sourceMappingURL=colors.js.map
